import React, { PureComponent } from 'react';
import { 
  Card, CardBody, Row, Col, Button, ButtonToolbar } from 'reactstrap';
import Select from 'react-select';
import { withTranslation } from 'react-i18next';
import { check, findAllMeioAmbienteTipologiaByEnabled } from "../../Services/MeioAmbienteTipologiaService";
import { findAllMeioAmbienteAreasByEnabled } from "../../Services/MeioAmbienteAreasService";
import { findAllMeioAmbienteGrupoByEnabled } from "../../Services/MeioAmbienteGrupoService";
import { findAllMeioAmbienteDivisaoByEnabled } from "../../Services/MeioAmbienteDivisaoService";
import { findAllMeioAmbienteClasseByEnabled } from "../../Services/MeioAmbienteClasseService";
import { findAllEstado } from "../../Services/EstadoService";
import { findCidadeByEstado } from "../../Services/CidadeService";
import { checkKey, hasGroupAccess } from "../../Services/SecurityService";
import { util } from "../../../shared/util";
import PropTypes from 'prop-types';
import { FullWideNotification } from '../../../shared/components/Notification';
import NotificationSystem from 'rc-notification';
import { environment } from '../../environment';

let notificationTC = null;

let prefeiturasAdministradores = false;
let prefeituras = false;

class CrudList extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);

    this.state = {
      checked: false,

      classesMap: {},

      estados: [],
      statesList: [],
      selectedStates: [{value:0, label: this.props.t('forms.loading')+"..."}],
      selectedEstados: [],

      cidades: [],
      citiesList: [],
      selectedCities: [],
      selectedCidades: [],
      
      divisoes: [],
      selectedDivisao: '',
      selectOptionsD: [],

      grupos: [],
      selectedGrupo: '',
      selectOptionsG: [],
      
      areas: [],
      selectedAreas: '',
      selectOptionsA: [],

      tipologias: [],
      tipologiasFiltered: [],
      selectedTipologia: '',
      selectedTipologiaObj: {},
      selectOptionsT: [],

      porte: '',

      municipioName: '',
      municipioNivel: '',
      municipioHabilitado: false,
      divisaoName: '',
      grupoName: '',
      areaName: '',
      tipologiaName: '',
      apto: false,
      classesQualificadas: []

    };
    check();
  }

  getPotencialPoluidor(value){
    let potencialPoluidorList= [
      {value:"P", label:this.props.t('forms.PEQUENO')},
      {value:"M", label:this.props.t('forms.MEDIO')},
      {value:"A", label:this.props.t('forms.ALTO')}
    ];
    let total = potencialPoluidorList.length;
    for(let i = 0; i < total; i++){
      if(potencialPoluidorList[i].value === value){
        return potencialPoluidorList[i].label;
      }
    }
  }

  loadMeioAmbienteClasse(){
    findAllMeioAmbienteClasseByEnabled(0)
    .then(data => {
      if(data === undefined){
        data = [];
      }
      if(data !== undefined && data.error === undefined){
        let classesMap = new Map();
        let code = "";
        for(let i = 0; i < data.length; i++){
          code = data[i].code;
          classesMap.set(code.toLowerCase(), data[i]);
        }
        this.setState({ classesMap });
      } else {
        if(data.errors === undefined){
          data = [];
          this.show('danger', this.props.t('forms.errorListData'));
        } else {
          data = [];
          this.show('danger', data.errors[0].defaultMessage);
        }
      }
    });
  }

  loadCidades(estado, cidade){
    let options = [];
    let cidades = [];
    let selectedCities = [];
    if(prefeiturasAdministradores || prefeituras){
      for(let i = 0; i < this.state.estados.length; i++){
        if(this.state.estados[i].id === estado.id){
          cidades = this.state.estados[i].cidades;
          if(cidades !== undefined && cidades !== null && cidades.length > 0){
            for(let i = 0; i < cidades.length; i++){
              options.push({value:cidades[i].id, label: cidades[i].name});
            }
          }
        }
      }
      this.setState({ 
        cidades,
        citiesList: options,
        selectedCities
      }, () => {
        if(cidade !== null){
          this.setCidade(cidade);
        }
      });
    }else{
      findCidadeByEstado(estado.id)
      .then(response => {
        if(response === undefined){
          response = [];
        }
        if(response !== undefined && response.error === undefined){
          cidades = response;
          if(cidades !== undefined && cidades !== null && cidades.length > 0){
            for(let i = 0; i < cidades.length; i++){
              options.push({value:cidades[i].id, label: cidades[i].name});
            }
          }
        } else {
          if(response.errors === undefined){
            response = [];
            this.show('danger', this.props.t('forms.errorListData'));
          } else {
            response = [];
            this.show('danger', response.errors[0].defaultMessage);
          }
        }
        this.setState({ 
          cidades,
          citiesList: options,
          selectedCities
        }, () => {
          if(cidade !== null){
            this.setCidade(cidade);
          }
        });
      });
    }
  }

  setCidade(cidade){
    let selectedCities = [];
    let selectedCidades = [];
    if(cidade !== null){
      for(let i = 0; i < this.state.cidades.length; i++){
        if(this.state.cidades[i].id === cidade.id){
          selectedCities.push({value: this.state.cidades[i].id, label: this.state.cidades[i].name});
          selectedCidades.push(this.state.cidades[i]);
          break;
        }
      }
    }
    this.setState({ selectedCities, selectedCidades }, () => {});
  }

  loadEstado(){
    if(prefeiturasAdministradores || prefeituras){
      let options = [];
      let estados = environment.getUserStateCities();
      
      if(estados !== undefined && estados !== null && estados.length > 0 && this.state.estados.length === 0){
        for(let i = 0; i < estados.length; i++){
          options.push({value:estados[i].id, label: estados[i].name});
        }
        this.setState({ 
          estados, 
          statesList: options
        }, () => {
          let user = environment.getUser();
          let stateFilter = environment.getStateFilter();
          let cityFilter = environment.getCityFilter();
          let state = null;
          let city = null;

          if(user !== null && user.cidade !== undefined && user.cidade !== null && user.cidade.id !== null){
            state = user.cidade.estado;
            city = user.cidade;
          }
          
          if(stateFilter !== null){
            if(state === null){
              state = {id: 0};
            }
            state.id = parseInt(stateFilter);
          }
          if(cityFilter !== null){
            if(city === null){
              city = {id: 0};
            }
            city.id = parseInt(cityFilter);
          }

          if(state !== undefined && state !== null && state.id !== null && state.id > 0){
            this.setEstado(state, city);
          }
        });
      }
    }else{
      findAllEstado()
      .then(response => {
        if(response === undefined){
          response = [];
        }
        let options = [];
        let estados = [];
        if(response !== undefined && response.error === undefined){
          estados = response;
          if(estados !== undefined && estados !== null && estados.length > 0 && this.state.estados.length === 0){
            for(let i = 0; i < estados.length; i++){
              options.push({value:estados[i].id, label: estados[i].name});
            }
            this.setState({ 
              estados,
              statesList: options
            }, () => {
              let user = environment.getUser();
              let stateFilter = environment.getStateFilter();
              let cityFilter = environment.getCityFilter();
              let state = null;
              let city = null;

              if(user !== null && user.cidade !== undefined && user.cidade !== null && user.cidade.id !== null){
                state = user.cidade.estado;
                city = user.cidade;
              }
              
              if(stateFilter !== null){
                if(state === null){
                  state = {id: 0};
                }
                state.id = parseInt(stateFilter);
              }
              if(cityFilter !== null){
                if(city === null){
                  city = {id: 0};
                }
                city.id = parseInt(cityFilter);
              }

              if(state !== undefined && state !== null && state.id !== null && state.id > 0){
                this.setEstado(state, city);
              }
            });
          }
        } else {
          if(response.errors === undefined){
            response = [];
            this.show('danger', this.props.t('forms.errorListData'));
          } else {
            response = [];
            this.show('danger', response.errors[0].defaultMessage);
          }
        }
      });
    }
  }

  setEstado(estado, cidade){
    let selectedStates = [];
    let selectedEstados = [];
    let citiesList = [];
    let selectedCities = [];
    let selectedCidades = [];

    if(estado !== null){
      for(let e = 0; e < this.state.estados.length; e++){
        if(this.state.estados[e].id === estado.id){
          selectedStates.push({value: this.state.estados[e].id, label: this.state.estados[e].name});
          selectedEstados.push(this.state.estados[e]);
          selectedCities.push({value:0, label: this.props.t('forms.loading')+"..."});
          break;
        }
      }
    }
    this.setState({ selectedStates, selectedEstados, citiesList, selectedCities, selectedCidades }, () => {
      if(selectedEstados.length > 0){
        this.loadCidades(estado, cidade);
      }
    });
  }

  loadMeioAmbienteAreas(){
    findAllMeioAmbienteAreasByEnabled(0)
    .then(data => {
      if(data === undefined){
        data = [];
      }
      if(data !== undefined && data.error === undefined){
        let areas = util.sortList(null, data, "code", null, null, false);
        this.loadMeioAmbienteGrupo(areas);
      } else {
        if(data.errors === undefined){
          data = [];
          this.show('danger', this.props.t('forms.errorListData'));
        } else {
          data = [];
          this.show('danger', data.errors[0].defaultMessage);
        }
      }
    });
  }

  loadMeioAmbienteGrupo(areas){
    findAllMeioAmbienteGrupoByEnabled(0)
    .then(data => {
      if(data === undefined){
        data = [];
      }
      if(data !== undefined && data.error === undefined){
        let grupos = util.sortList(null, data, "code", null, null, false);
        for(let i = 0; i < grupos.length; i++){
          grupos[i].areas = [];
          for(let j = 0; j < areas.length; j++){
            if(areas[j].meioAmbienteGrupo !== null && areas[j].meioAmbienteGrupo.id === grupos[i].id){
              grupos[i].areas.push(areas[j]);
            }
          }
        }
        this.loadMeioAmbienteDivisao(grupos);
      } else {
        if(data.errors === undefined){
          data = [];
          this.show('danger', this.props.t('forms.errorListData'));
        } else {
          data = [];
          this.show('danger', data.errors[0].defaultMessage);
        }
      }
    });
  }

  loadMeioAmbienteDivisao(grupos){
    findAllMeioAmbienteDivisaoByEnabled(0)
    .then(data => {
      if(data === undefined){
        data = [];
      }
      if(data !== undefined && data.error === undefined){
        let options = [];
        for(let i = 0; i < data.length; i++){
          data[i].grupos = [];
          for(let j = 0; j < grupos.length; j++){
            if(grupos[j].meioAmbienteDivisao !== null && grupos[j].meioAmbienteDivisao.id === data[i].id){
              data[i].grupos.push(grupos[j]);
            }
          }
          options.push({value:data[i].id, label: data[i].code + " - " + data[i].name});
        }

        this.setState({ 
          selectOptionsD: options, 
          divisoes: data
        });
      } else {
        if(data.errors === undefined){
          data = [];
          this.show('danger', this.props.t('forms.errorListData'));
        } else {
          data = [];
          this.show('danger', data.errors[0].defaultMessage);
        }
      }
    });
  }

  loadMeioAmbienteTipologia(){
    findAllMeioAmbienteTipologiaByEnabled(0)
    .then(data => {
      if(data === undefined){
        data = [];
      }
      if(data !== undefined && data.error === undefined){
        let options = [];
        let tipologias = util.sortList(null, data, "code", null, null, false);
        for(let i = 0; i < tipologias.length; i++){
          options.push({value:tipologias[i].id, label: tipologias[i].code + " - " + tipologias[i].name});
        }
        this.setState({ 
          selectOptionsT: options, 
          tipologiasFiltered: tipologias,
          tipologias
        });
      } else {
        if(data.errors === undefined){
          data = [];
          this.show('danger', this.props.t('forms.errorListData'));
        } else {
          data = [];
          this.show('danger', data.errors[0].defaultMessage);
        }
      }
    });
  }

  componentDidMount() {
    NotificationSystem.newInstance({ style: { top: 65 } }, n => notificationTC = n);
    if(checkKey("MENU_MEIO_AMBIENTE_ENQUADRAMENTO_VIEW")){
      prefeiturasAdministradores = hasGroupAccess("PREFEITURAS_ADMINISTRADORES");
      prefeituras = hasGroupAccess("PREFEITURAS");

      this.loadEstado();
      this.loadMeioAmbienteClasse();
      this.loadMeioAmbienteTipologia();
      this.loadMeioAmbienteAreas();
    }
  }

  componentWillUnmount() {
    notificationTC.destroy();
  }

  
  updateField(event) {
    let porte = event.target.value;
    this.setState({ porte })
  }


  updateStatesFieldSelect(event) {
    if(event !== null && event.length > 0){
      for(let j = (event.length-1); j < event.length; j++){
        this.setEstado({id: event[j].value}, null);
      }
    }else{
      this.setEstado(null, null);
    }
  }

  updateCitiesFieldSelect(event) {
    if(event !== null && event.length > 0){
      for(let j = (event.length-1); j < event.length; j++){
        this.setCidade({id: event[j].value}, false);
      }
    }else{
      this.setCidade(null, false);
    }
  }

  updateDivisaoSelect(event) {
    let selectedDivisao = '';

    let grupos = [];
    let selectedGrupo = '';
    let selectOptionsG = [];

    let selectedAreas = '';
    let selectOptionsA = [];
    
    let selectedTipologia = '';
    let selectedTipologiaObj = {};

    let tipologiaList = [];
    let selectOptionsT = [];

    if(event !== null && event.length > 0){
      for(let j = 0; j < event.length; j++){
        selectOptionsT = [];
        for(let i = 0; i < this.state.selectOptionsD.length; i++){
          if(this.state.selectOptionsD[i].value === event[j].value){
            selectedDivisao = event[j];
            
            for(let e = 0; e < this.state.divisoes.length; e++){
              if(this.state.divisoes[e].id === selectedDivisao.value){
                let options = [];
                //grupos = util.sortList(null, this.state.divisoes[e].grupos, "code", null, null, false);
                grupos = this.state.divisoes[e].grupos;
                for(let j = 0; j < grupos.length; j++){
                  options.push({value:grupos[j].id, label: grupos[j].code + " - " + grupos[j].name});

                  tipologiaList = this.state.tipologias.filter(
                    obj => (obj.meioAmbienteGrupo !== null && obj.meioAmbienteGrupo.id === grupos[j].id)
                  );
                  for(let t = 0; t < tipologiaList.length; t++){
                    selectOptionsT.push({value:tipologiaList[t].id, label: tipologiaList[t].code + " - " + tipologiaList[t].name});
                  }
                }
                selectOptionsG = options;
                break;
              }
            }
            break;
          }
        }
      }
    } else{
      for(let t = 0; t < this.state.tipologias.length; t++){
        selectOptionsT.push({value:this.state.tipologias[t].id, label: this.state.tipologias[t].code + " - " + this.state.tipologias[t].name});
      }
    }
    this.setState({ 
      selectedDivisao, 
      selectedGrupo, selectOptionsG, grupos, 
      selectedAreas, selectOptionsA,
      selectedTipologia, selectedTipologiaObj,
      selectOptionsT
    });
  }
  

  updateGrupoSelect(event) {
    let selectedGrupo = '';

    let areas = [];
    let selectedAreas = '';
    let selectOptionsA = [];
    
    let selectedTipologia = '';
    let selectedTipologiaObj = {};

    let tipologiaList = [];
    let selectOptionsT = [];

    if(event !== null && event.length > 0){
      for(let j = 0; j < event.length; j++){
        selectOptionsT = [];
        for(let i = 0; i < this.state.selectOptionsG.length; i++){
          if(this.state.selectOptionsG[i].value === event[j].value){
            selectedGrupo = event[j];
            
            for(let e = 0; e < this.state.grupos.length; e++){
              if(this.state.grupos[e].id === selectedGrupo.value){
                let options = [];
                //areas = util.sortList(null, this.state.grupos[e].areas, "code", null, null, false);
                areas = this.state.grupos[e].areas;
                for(let j = 0; j < areas.length; j++){
                  options.push({value:areas[j].id, label: areas[j].code + " - " + areas[j].name});
                }
                selectOptionsA = options;

                tipologiaList = this.state.tipologias.filter(
                  obj => (obj.meioAmbienteGrupo !== null && obj.meioAmbienteGrupo.id === selectedGrupo.value)
                );
                for(let t = 0; t < tipologiaList.length; t++){
                  selectOptionsT.push({value:tipologiaList[t].id, label: tipologiaList[t].code + " - " + tipologiaList[t].name});
                }
                break;
              }
            }
            break;
          }
        }
      }
    }else{
      for(let e = 0; e < this.state.divisoes.length; e++){
        if(this.state.divisoes[e].id === this.state.selectedDivisao.value){
          let grupos = this.state.divisoes[e].grupos;
          for(let j = 0; j < grupos.length; j++){
            tipologiaList = this.state.tipologias.filter(
              obj => (obj.meioAmbienteGrupo !== null && obj.meioAmbienteGrupo.id === grupos[j].id)
            );
            for(let t = 0; t < tipologiaList.length; t++){
              selectOptionsT.push({value:tipologiaList[t].id, label: tipologiaList[t].code + " - " + tipologiaList[t].name});
            }
          }
          break;
        }
      }
    }
    this.setState({ 
      selectedGrupo, 
      selectedAreas, selectOptionsA, areas, 
      selectedTipologia, selectedTipologiaObj,
      selectOptionsT
    });
  }

  updateAreasSelect(event) {
    let selectedAreas = '';

    let selectedTipologia = '';
    let selectedTipologiaObj = {};

    let tipologiaList = [];
    let selectOptionsT = [];

    if(event !== null && event.length > 0){
      for(let j = 0; j < event.length; j++){
        selectOptionsT = [];
        for(let i = 0; i < this.state.selectOptionsA.length; i++){
          if(this.state.selectOptionsA[i].value === event[j].value){
            selectedAreas = event[j];
            
            for(let e = 0; e < this.state.areas.length; e++){
              if(this.state.areas[e].id === selectedAreas.value){
                tipologiaList = this.state.tipologias.filter(
                  obj => (obj.meioAmbienteAreas !== null && obj.meioAmbienteAreas.id === selectedAreas.value)
                );
                for(let t = 0; t < tipologiaList.length; t++){
                  selectOptionsT.push({value:tipologiaList[t].id, label: tipologiaList[t].code + " - " + tipologiaList[t].name});
                }
                break;
              }
            }
            break;
          }
        }
      }
    }else{
      for(let e = 0; e < this.state.grupos.length; e++){
        if(this.state.grupos[e].id === this.state.selectedGrupo.value){
          tipologiaList = this.state.tipologias.filter(
            obj => (obj.meioAmbienteGrupo !== null && obj.meioAmbienteGrupo.id === this.state.selectedGrupo.value)
          );
          for(let t = 0; t < tipologiaList.length; t++){
            selectOptionsT.push({value:tipologiaList[t].id, label: tipologiaList[t].code + " - " + tipologiaList[t].name});
          }
          break;
        }
      }
    }
    this.setState({ 
      selectedAreas,
      selectedTipologia, selectedTipologiaObj,
      selectOptionsT
     });
  }

  updateTipologiaSelect(event) {
    let selectedTipologia = '';
    let selectedTipologiaObj = {};
    if(event !== null){
      for(let j = 0; j < event.length; j++){
        for(let i = 0; i < this.state.selectOptionsT.length; i++){
          if(this.state.selectOptionsT[i].value === event[j].value){
            selectedTipologia = event[j];
            
            for(let e = 0; e < this.state.tipologiasFiltered.length; e++){
              if(this.state.tipologiasFiltered[e].id === selectedTipologia.value){
                selectedTipologiaObj = this.state.tipologiasFiltered[e];
                break;
              }
            }
            break;
          }
        }
      }
    }
    this.setState({ selectedTipologia, selectedTipologiaObj });
  }

  updatePotencialPoluidorSelect(event) {
    let selectedPotencialPoluidor = '';
    if(event !== null){
      for(let j = 0; j < event.length; j++){
        for(let i = 0; i < this.state.potencialPoluidorList.length; i++){
          if(this.state.potencialPoluidorList[i].value === event[j].value){
            selectedPotencialPoluidor = event[j];
            break;
          }
        }
      }
    }
    this.setState({ selectedPotencialPoluidor });
  }



  validateEntries(){
    const { 
      selectedEstados, selectedCidades, selectedTipologiaObj, porte 
    } = this.state;

    let validated = true;

    if(selectedEstados === undefined || selectedEstados === null || selectedEstados.length === 0){
      this.show('danger', this.props.t('forms.requiredFieldState'));
      validated = false;
    }

    if(selectedCidades === undefined || selectedCidades === null || selectedCidades.length === 0){
      this.show('danger', this.props.t('forms.requiredFieldCity'));
      validated = false;
    }

    if(selectedTipologiaObj === undefined || selectedTipologiaObj === null || 
      selectedTipologiaObj.id === undefined || selectedTipologiaObj.id === null || selectedTipologiaObj.id === 0){
      this.show('danger', this.props.t('forms.requiredFieldMeioAmbienteTipologia'));
      validated = false;
    }

    if(porte === undefined || porte === null || porte === ''){
      this.show('danger', this.props.t('forms.requiredFieldPorte'));
      validated = false;
    }

    return validated;
  }


  checar = () => {
    let municipioName = "";
    let municipioNivel = "";
    let municipioHabilitado = false;

    let divisaoName = "";
    let grupoName = "";
    let areaName = "";
    let tipologiaName = "";
    let competenciaNivel = "";
    let potencialPoluidor = "";
    let porte = "";

    let apto = false;
    let classesQualificadas = [];
    let classe = {};
    let cidade = {};
    let estado = {};

    if(this.validateEntries()){

      cidade = this.state.selectedCidades[0];
      estado = this.state.selectedEstados[0];

      if(cidade.id !== undefined && cidade.id !== null){
        municipioName = cidade.name;
        if(estado.id !== undefined && estado.id !== null){
          municipioName += " - " + estado.name;
        }

        if(cidade.nivelHabilitadoLicenciamento !== null && 
          cidade.nivelHabilitadoLicenciamento !== undefined && 
          cidade.nivelHabilitadoLicenciamento > 0){
              municipioHabilitado = true;
              municipioNivel = this.props.t('forms.situacaoMunicipioDesc1')
                + " " + cidade.nivelHabilitadoLicenciamento 
                + this.props.t('forms.situacaoMunicipioDesc2') 
                + " " + util.formatDateToString(cidade.nivelHabilitadoLicenciamentoData);
        }else{
          municipioNivel = this.props.t('forms.situacaoMunicipioDesc3') ;
        }
      }
    
      if(this.state.selectedTipologia.value !== undefined && this.state.selectedTipologia.value !== null){
        divisaoName = this.state.selectedTipologiaObj.meioAmbienteGrupo.meioAmbienteDivisao.code + " - " + this.state.selectedTipologiaObj.meioAmbienteGrupo.meioAmbienteDivisao.name;
        grupoName = this.state.selectedTipologiaObj.meioAmbienteGrupo.code + " - " + this.state.selectedTipologiaObj.meioAmbienteGrupo.name;
        if(this.state.selectedTipologiaObj.meioAmbienteAreas !== null && this.state.selectedTipologiaObj.meioAmbienteAreas !== undefined){
          areaName = this.state.selectedTipologiaObj.meioAmbienteAreas.code + " - " + this.state.selectedTipologiaObj.meioAmbienteAreas.name;
        }
        tipologiaName = this.state.selectedTipologiaObj.code + " - " + this.state.selectedTipologiaObj.name;

        if(municipioHabilitado){
          potencialPoluidor = this.state.selectedTipologiaObj.potencialPoluidor;

          switch(cidade.nivelHabilitadoLicenciamento){
            case 1:
              competenciaNivel = this.state.selectedTipologiaObj.competenciaNivel1;
            break;

            case 2:
              competenciaNivel = this.state.selectedTipologiaObj.competenciaNivel2;
            break;

            case 3:
              competenciaNivel = this.state.selectedTipologiaObj.competenciaNivel3;
            break;
          }

          if(this.state.porte < this.state.selectedTipologiaObj.portePequeno){
            porte = "";
          }else if(this.state.porte >= this.state.selectedTipologiaObj.portePequeno && this.state.porte < this.state.selectedTipologiaObj.porteMedio){
            porte = "pequeno_porte";
          }else if(this.state.porte >= this.state.selectedTipologiaObj.porteMedio && this.state.porte < this.state.selectedTipologiaObj.porteGrande){
            porte = "medio_porte";
          }else if(this.state.porte >= this.state.selectedTipologiaObj.porteGrande){
            porte = "grande_porte";
          }

          let codes = [];
          if(competenciaNivel.indexOf(",")){
            let compV = competenciaNivel.split(",");
            for(let i = 0; i < compV.length; i++){
              if(compV[i].indexOf("e")){
                let compE = compV[i].split("e");
                for(let j = 0; j < compE.length; j++){
                  codes.push(compE[j].trim().toLocaleLowerCase());
                }
              }else{
                codes.push(compV[i].trim().toLocaleLowerCase());
              }
            } 
          }else{
            if(competenciaNivel.indexOf("e")){
              let compE = competenciaNivel.split("e");
              for(let j = 0; j < compE.length; j++){
                codes.push(compE[j].trim().toLocaleLowerCase());
              }
            }else{
              codes.push(competenciaNivel.trim().toLocaleLowerCase());
            }
          }
          
          for(let i = 0; i < codes.length; i++){
            // if(!apto){
              classe = this.state.classesMap.get(codes[i]);
              if(classe.porteCondition1 === porte && classe.potencialPoluidorCondition1 === potencialPoluidor){
                apto = true;
                classesQualificadas.push(classe);
              }else if(classe.porteCondition2 !== null && classe.porteCondition2 !== undefined && classe.porteCondition2.length > 0){
                if(classe.porteCondition2 === porte && classe.potencialPoluidorCondition2 === potencialPoluidor){
                  apto = true;
                  classesQualificadas.push(classe);
                } 
              }
            // }else{
            //   break;
            // }
          }
        }
      }   

      setTimeout(
        () => this.scrollBottom(), 
        500
      );

      this.setState({ 
        municipioName, municipioNivel, municipioHabilitado,
        divisaoName, grupoName, areaName, tipologiaName,
        apto, classesQualificadas, checked: true
      });
    }
  }

  clear(){
    let selectOptionsT = [];
    for(let t = 0; t < this.state.tipologias.length; t++){
      selectOptionsT.push({value:this.state.tipologias[t].id, label: this.state.tipologias[t].code + " - " + this.state.tipologias[t].name});
    }
    this.setState({ 
      checked: false,

      selectedStates: '',
      selectedEstados: [],

      citiesList: [],
      selectedCities: '',
      selectedCidades: [],
      
      selectedDivisao: '',

      selectedGrupo: '',
      selectOptionsG: [],
      
      selectedAreas: '',
      selectOptionsA: [],

      tipologiasFiltered: this.state.tipologias,
      selectedTipologia: '',
      selectedTipologiaObj: {},
      selectOptionsT,

      porte: '',

      municipioName: '',
      municipioNivel: '',
      municipioHabilitado: false,
      divisaoName: '',
      grupoName: '',
      areaName: '',
      tipologiaName: '',
      apto: false,
      classesQualificadas: []
    }, () => {});
  }

  cancel(event) {
    this.clear();
    this.props.updateTable({});
  }

  show = (color, message) => {
    return notificationTC.notice({
      content: <FullWideNotification
        color={color}
        message={message}
        />,
      duration: 3,
      closable: true,
      style: { top: 0, left: 0 },
      className: `full ltr-support`,
    });
  };

  scrollBottom() {
      window.scrollTo(0,document.body.scrollHeight);
      //console.log(document.body.scrollHeight);
  }

  render() {
    const { t } = this.props;
    const { 
      municipioName, municipioNivel,
      divisaoName, grupoName, areaName, tipologiaName,
      apto, classesQualificadas, checked
    } = this.state;

    //console.log(this.refs);

    let unidadeMedida = [];
    if(this.state.selectedTipologia.value !== undefined && this.state.selectedTipologia.value !== null){
      //console.log(this.state.selectedTipologiaObj);
      unidadeMedida.push(
        <span key="pkey" className="form__form-group-label">
          <b>{t('forms.unidadeMedida')}</b>: {this.state.selectedTipologiaObj.unidadeMedida}
        </span>
      );
    }

    let result = '';
    if(checked){

      let tipologiaList = [];
      let classesQualificadasList = [];

      if(divisaoName !== null && divisaoName.length > 0){
        tipologiaList.push(<i key="dkey">{divisaoName}<br /></i>);
      }
      if(grupoName !== null && grupoName.length > 0){
        tipologiaList.push(<i key="bkey">{grupoName}<br /></i>);
      }
      if(areaName !== null && areaName.length > 0){
        tipologiaList.push(<i key="akey">{areaName}<br /></i>);
      }

      if(tipologiaName !== null && tipologiaName.length > 0){
        tipologiaList.push(<b key="tkey"><i key="tkeyi">{tipologiaName}</i><br /></b>);
        tipologiaList.push(
          <ul key="ulkey" style={{marginLeft: '20px'}}>
            <li key="likey1">{"Unidade de Medida do Porte: "}<i key="likey1_i">{this.state.selectedTipologiaObj.unidadeMedida}</i></li>
            <li key="likey2">{"Pequeno Porte: "}<i key="likey2_i">Entre {this.state.selectedTipologiaObj.portePequeno} e {this.state.selectedTipologiaObj.porteMedio}</i></li>
            <li key="likey3">{"Médio Porte: "}<i key="likey3_i">Entre {this.state.selectedTipologiaObj.porteMedio} e {this.state.selectedTipologiaObj.porteGrande}</i></li>
            <li key="likey4">{"Grande Porte: "}<i key="likey4_i">Maior que {this.state.selectedTipologiaObj.porteGrande}</i></li>
            <li key="likey5">{"Potencial Poluidor: "}<i key="likey5_i">{this.getPotencialPoluidor(this.state.selectedTipologiaObj.potencialPoluidor)}</i></li>
          </ul>
        );
      }

      let municipioHabilitado = "forms.municipioHabilitadoS";
      if(apto){
        for(let i = 0; i < classesQualificadas.length; i++){
          classesQualificadasList.push(
            <i key={"ckeyi"+i}><b key={"ckey"+i}>{classesQualificadas[i].code}</b>{" - " + classesQualificadas[i].name}<br /></i>
          );
        }
      }else{
        municipioHabilitado = "forms.municipioHabilitadoN";
      }



      result = <Row>
                <Col md={12} lg={12}>
                  <Card>
                    <CardBody>
                      <div key="municipioKey">
                          <span><b>{t('forms.municipio')}</b><br /></span>
                          {municipioName}
                      </div>
                      <div key="municipioNivelKey" style={{marginTop: '15px'}}>
                        <span><b>{t('forms.situacaoMunicipio')}</b><br /></span>
                        {municipioNivel}
                      </div>
                      <div key="tipologiaKey" style={{marginTop: '15px'}}>
                          <span><b>{t('forms.tipologia')}: </b><br /></span>
                          {tipologiaList}
                      </div>
                      <div key="municipioHabilitadoKey" id="municipioHabilitadoId" style={{marginTop: '15px'}}>
                          <span><b>{t(municipioHabilitado)} </b><br /></span>
                          {classesQualificadasList}
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              </Row>;

    }
    

    return (
      <>
        <Row>
          <Col md={10}>
            <h3 className="page-title">{t('forms.meioAmbienteEnquadramento_form.title')}</h3>
            <h3 className="page-subhead subhead">{t('forms.meioAmbienteEnquadramento_form.description')}</h3>
          </Col>
        </Row>

        <Row>
          <Col md={12} lg={12}>
            <Card>
              <CardBody>
                <div className="form">

                  <div className="form__half">
                    <div key="stateKey" style={{marginTop: '10px'}}>
                      <span>Estados</span>
                      <Select
                        isMulti = "false"
                        maxMenuHeight="200px"
                        name="states"
                        value={this.state.selectedStates}
                        onChange={e => this.updateStatesFieldSelect(e)}
                        options={this.state.statesList}
                        clearable={true}
                        className="react-select"
                        classNamePrefix="react-select"
                      />
                    </div>
                  </div>
                  <div className="form__half">
                    <div key="cityKey" style={{marginTop: '10px'}}>
                      <span>Cidades</span>
                      <Select
                        isMulti = "false"
                        maxMenuHeight="200px"
                        name="cities"
                        value={this.state.selectedCities}
                        onChange={e => this.updateCitiesFieldSelect(e)}
                        options={this.state.citiesList}
                        clearable={true}
                        className="react-select"
                        classNamePrefix="react-select"
                      />
                    </div>
                  </div>

                  <div className="form__form-group" style={{marginTop: '20px'}}>
                    <span className="form__form-group-label">
                      {t('forms.meioAmbienteDivisao_form.shortTitle')} 
                    </span>
                    <div className="form__form-group-field">
                      <Select
                        isMulti = "true"
                        maxMenuHeight="150px"
                        name="meioAmbienteDivisao"
                        value={this.state.selectedDivisao}
                        onChange={e => this.updateDivisaoSelect(e)}
                        options={this.state.selectOptionsD}
                        clearable={true}
                        className="react-select"
                        classNamePrefix="react-select"
                      />
                    </div>
                  </div>

                  <div className="form__form-group">
                    <span className="form__form-group-label">
                      {t('forms.meioAmbienteGrupo_form.shortTitle')} 
                    </span>
                    <div className="form__form-group-field">
                      <Select
                        isMulti = "true"
                        maxMenuHeight="150px"
                        name="meioAmbienteGrupo"
                        value={this.state.selectedGrupo}
                        onChange={e => this.updateGrupoSelect(e)}
                        options={this.state.selectOptionsG}
                        clearable={true}
                        className="react-select"
                        classNamePrefix="react-select"
                      />
                    </div>
                  </div>

                  <div className="form__form-group">
                    <span className="form__form-group-label">
                      {t('forms.meioAmbienteAreas_form.shortTitle')} 
                    </span>
                    <div className="form__form-group-field">
                      <Select
                        isMulti = "true"
                        maxMenuHeight="150px"
                        name="meioAmbienteAreas"
                        value={this.state.selectedAreas}
                        onChange={e => this.updateAreasSelect(e)}
                        options={this.state.selectOptionsA}
                        clearable={true}
                        className="react-select"
                        classNamePrefix="react-select"
                      />
                    </div>
                  </div>

                  <div className="form__form-group">
                    <span className="form__form-group-label">
                      {t('forms.meioAmbienteTipologia_form.shortTitle')} 
                    </span>
                    <div className="form__form-group-field">
                      <Select
                        isMulti = "true"
                        maxMenuHeight="150px"
                        name="meioAmbienteTipologia"
                        value={this.state.selectedTipologia}
                        onChange={e => this.updateTipologiaSelect(e)}
                        options={this.state.selectOptionsT}
                        clearable={true}
                        className="react-select"
                        classNamePrefix="react-select"
                      />
                    </div>
                  </div>
                </div>

                <div className="form">
                  <div className="form__half">
                    <div key="stateKey" style={{marginTop: '10px'}}>
                      <span title={t('forms.requiredField')} className="form__form-group-label">
                       {t('forms.porte')}  <span style={{color: "#ff0000"}}>*</span>
                      </span>
                      <br />
                      {unidadeMedida}
                      <input type="number" 
                        name="porte"
                        value={this.state.porte}
                        onChange={e => this.updateField(e)}
                      />
                    </div>
                  </div>
                  <div className="form__half">
                    
                  </div>

                  <div className="form__form-group">
                    <ButtonToolbar className="form__button-toolbar" style={{float: 'right'}}>
                      <Button color="primary" type="submit" 
                        onClick={e => this.checar()}>
                        {t('forms.checkLicenciamento')}
                      </Button>
                      <Button color="primary" type="submit" 
                        onClick={e => this.clear()}>
                        {t('forms.clear')}
                      </Button>
                    </ButtonToolbar>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>

        {result}
      </>
    );
  }
}

export default withTranslation('common')(CrudList);